export {
  Badge,
  type BadgeProps,
  BadgeColor,
  BadgeSize,
} from './Badge';
